<p-scrollPanel [style]="{ width: '100%', height: '100%' }">
  <form [formGroup]="form.formGroup" class="h-full min-h-0 flex flex-col">

    <div class="field pb-6">
      <label>Packer Name</label>
      <p-inputgroup>
        <input id="packer-name" type="text" pInputText [formControlName]="form.formControlNames.name" />
      </p-inputgroup>
    </div>

      <p-tabs value="0" class="flex flex-col flex-1 min-h-0">
        <p-tablist>
          <p-tab value="0">Packer Data </p-tab>
          <p-tab value="1">Seal Bore</p-tab>
          <p-tab value="2">Packer Envelope</p-tab>
          <p-tab value="3">Schematic</p-tab>
        </p-tablist>

        <p-tabpanels class="w-full h-full flex-1 min-h-0">
          <p-tabpanel value="0">
            <div class="flex flex-col space-y-2">
              <div class="flex flex-col">
                <label>Setting Type</label>
                <p-select class="w-full" (onChange)="typeChange()" [formControlName]="form.formControlNames.type"
                  optionValue="value" optionLabel="label" [options]="packerTypes"></p-select>
              </div>

              <div class="field">
                <label>Packer Depth</label>
                <app-validated-number-input
                  [id]="'measuredDepth'"
                  [control]="control('measuredDepth')"
                  [value]="control('measuredDepth').value"
                  [validation]="{ min: packerMinDepth, max: packerDefaultDepth }"
                  (onChange)="validatePackers()"
                  [unit]="userUnits?.longLengths || 'ft'"
                  [unitPrecisionOverrides]="{ 'ft': 3, 'm': 3 }"
                  [title]="`Allowed Range: ${packerMinDepth} - ${packerDefaultDepth} ${userUnits?.longLengths || 'ft'}`"
                ></app-validated-number-input>
              </div>

              <div [style.display]="form.formGroup.controls.type.value === 'Hydraulic' ||
                form.formGroup.controls.type.value === 'Hydrostatic' ? 'block' : 'none'">
                <div class="flex flex-col">
                  <label>Initial Set Pressure</label>
                  <app-validated-number-input
                    [id]="'initialSetPressure'"
                    [control]="control('initialSetPressure')"
                    [value]="control('initialSetPressure').value"
                    [validation]="{ min: 0, max: 10000000 }"
                    [unit]="pressureUnit"
                  ></app-validated-number-input>
                </div>
              </div>
              
              <div [style.display]="form.formGroup.controls.type.value === 'Hydraulic' ? 'block' : 'none'">
                <div class="flex flex-col">
                  <label>Plug Depth</label>
                  <app-validated-number-input
                    [id]="'plugDepth'"
                    [control]="control('plugDepth')"
                    [value]="control('plugDepth').value"
                    [validation]="
                      form.formGroup.controls.plugDepth.invalid &&
                      form.formGroup.controls.plugDepth.value &&
                      form.formGroup.controls.type.value === 'Hydraulic' ?
                       { min: packerMinDepth, max: packerDefaultDepth } :
                       { min: 0, max: 10000000 }"
                    (onChange)="validatePackers()"
                    [unit]="(userUnits?.longLengths || 'ft') + ' MD'"
                  ></app-validated-number-input>
                </div>
              </div>

              <div class="flex flex-col">
                <div class="flex-row">
                  <label>Pickup/Slackoff </label>
                  <i pTooltip="Pickup (+)/Slackoff (-)" class="pi pi-info-circle cursor-help"></i>
                </div>
                <p-inputgroup>
                  <p-inputnumber [maxFractionDigits]="3" [minFractionDigits]="1" [formControlName]="form.formControlNames.pickupForce" />
                  <p-inputgroup-addon>{{ forceUnit }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <div class="w-full pb-5">
                <label>Anchor/ASV:</label>

                <hr style="height: 2px; margin-bottom: 10px" />

                <div class="flex items-center space-x-2">
                  <p-checkbox inputId="isPressureBarrier" size="small" binary="true" [formControlName]="form.formControlNames.isPressureBarrier">
                  </p-checkbox>
                  <label class="pt-1" for="isPressureBarrier">
                    Annulus pressure barrier
                    <i pTooltip="Uncheck if Anchor or Open ASV" class="pi pi-info-circle cursor-help"></i>
                  </label>
                </div>

              </div>
            </div>
          </p-tabpanel>

          <p-tabpanel value="1">
            <p-fieldset>
              <ng-template pTemplate="header">
                <div class="flex items-center space-x-2">
                  <p-checkbox (onChange)="expansionJointChange($event)" inputId="hasExpansionJoint" size="small" binary="true" [formControlName]="form.formControlNames.hasExpansionJoint"></p-checkbox>
                  <label class="pt-1" for="hasExpansionJoint">Seal Bore / PBR / Expansion Joint</label>
                </div>
              </ng-template>

              <!-- @if (packerDepth) { -->
                <app-expansion-joint
                  [class.pointer-events-none]="!form.formGroup.controls.hasExpansionJoint.value"
                  [class.opacity-50]="!form.formGroup.controls.hasExpansionJoint.value"
                  [formControlName]="form.formControlNames.advancedExpansionJoint"
                  [defaultPbrDepth]="packerDepth || form.formGroup.controls.measuredDepth.value"
                  [hasExpansionJoint]="form.formGroup.controls.hasExpansionJoint.value" [userUnits]="userUnits"
                  [defaultSealBoreDiameter]="defaultSealBoreDiameter" [packerDepth]="packerDepth || form.formGroup.controls.measuredDepth.value"
                ></app-expansion-joint>
              <!-- } -->
            </p-fieldset>
          </p-tabpanel>

          <p-tabpanel value="2" class="h-full min-h-0">
              <div class="flex items-center space-x-2">
                <p-toggleswitch (onChange)="tablePlotToggle($event)" binary="true"></p-toggleswitch>
                <label class="pb-1">Table/Plot</label>
              </div>

              <div class="w-full h-full min-h-0 flex flex-col">
                @if (selectedResultDisplay()) {
                  <app-xy-line-plot 
                    [plotData]="plot.data" 
                    [xAxisTitle]="xAxisTitle"
                    [yAxisTitle]="yAxisTitle" 
                    [plotName]="plotName" 
                    [downloadPlotName]="downloadPlotName"
                    [plotTitle]="'Packers'" 
                    [reverseAutoRange]="true" 
                    [btmMargin]="60"
                    [xyLinePlotStore]="packersStore"
                    class="block flex-1 min-h-0"
                  ></app-xy-line-plot>
                }

                <app-units-grid-input
                  [hidden]="selectedResultDisplay()"
                  [tableTitle]="'Packer Envelope'"
                  [rows]="packerEnvelopeRows"
                  [columns]="envelopeColumns"
                  [userUnits]="userUnits"
                  [autoHeight]="true"
                  [autoHeightOffset]="220"
                  [allowDeleteRows]="true"
                  [minRows]="1"
                  [createRow]="createPackerEnvelopeRow"
                  [dedupePasteByFirstColumn]="false"
                  [sortPasteByFirstColumn]="false"
                  [commitMode]="'debounced'"
                  [commitDebounceMs]="300"
                  (cellEdited)="onPackerEnvelopeGridChange()"
                  (commitRequested)="onPackerEnvelopeGridChange()"
                  (rowDeleted)="onPackerEnvelopeRowDeleted($event)"
                  (rowsReset)="onPackerEnvelopeGridChange()"
                  (pasteApplied)="onPackerEnvelopeGridChange()"
                />
              </div>
          </p-tabpanel>

          <p-tabpanel value="3">
              <app-packer-schematic
                [packerIndex]="packerIndex"
                [tubularId]="currentString?.id"
                [packerName]="form.formGroup.value.name"
              ></app-packer-schematic>
          </p-tabpanel>

        </p-tabpanels>

      </p-tabs>

  </form>
  <!-- <pre>{{ form.formGroupErrors | json }}</pre> -->
</p-scrollPanel>
